export const PurchaseIntent = Object.freeze({
  TRY: 'try',
  BUY: 'buy',
  GET: 'get'
});
export const CTAKind = Object.freeze({
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
});
export const HostingOptionKind = Object.freeze({
  // The hosting option is native to the listing
  // and clicking on it would just switch hosting types
  NATIVE: 'native',
  // The hosting option links to another listing
  ALTERNATE: 'alternate',
  // The hosting option is not officially supported, and
  // leads to informational content
  INFORMATIONAL: 'informational'
});
export const MediaViewerResource = Object.freeze({
  Highlight: 'Highlight image',
  Screenshot: 'Screenshot'
});